module.exports = __webpack_public_path__ + "static/media/light-blue.587930fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/light-blue.svg
// module id = 77
// module chunks = 0